/* eslint-disable */
import { HttpClient, RequestParams } from "./http-client";

export class AdminLogs<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  attempts = (query: { search?: string; skip?: number; take?: number }, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminLogs/Attempts`, method: "GET", query, secure: true, ...params });
  deleteAttempt = (id: string, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminLogs/Attempt/${id}`, method: "DELETE", secure: true, ...params });
  chat = (query: { search?: string; skip?: number; take?: number }, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminLogs/Chat`, method: "GET", query, secure: true, ...params });
  deleteChat = (id: string, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminLogs/Chat/${id}`, method: "DELETE", secure: true, ...params });
}
